module.exports = __webpack_public_path__ + "img/ecosagety_logo_group_2018.d4c6ce7d.png";